exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".groupBarWithoutAxis .barstext,.groupBarWithoutAxis__label{font-size:10px}.groupBarWithoutAxis .axis text{font-size:10px !important}.groupBarWithoutAxis__label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;padding:5px 0 2px 0}.groupBarWithoutAxis__label span{width:10px;height:10px;background-color:#4472c4;margin:0 5px 0 5px}.groupBarWithoutAxis_no_data{text-transform:uppercase;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:100%}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/groupBarWithoutAxis/groupBarWithoutAxis.style.scss
// module id = 1622
// module chunks = 0